<template>
  <div>
    <d-form @submit="doCreate">
      <d-form-input
          class-name="mb-3"
          label="Name"
          :rules="isUpdate?'': 'required|max:255'"
          placeholder="Enter name"
          :required="true"
          type="text"
          v-model="form.name"
      />
      <d-form-file
          class="mb-3"
          accept=".EMB"
          v-model="form.designs"
          :rules="!isUpdate && 'required'"
          label="Design (.EMB)"
      />
      <d-form-input
          class-name="mb-3"
          label="Design cost"
          :rules="null"
          placeholder="Enter cost"
          type="number"
          v-model="form.designCost"
      />
      <div class="mb-3">
        <div class="mb-1">Thumb</div>
        <image-select v-model="form.thumb"/>
      </div>
      <div class="text-center m-t-20">
        <d-button
            type="primary"
            inputType="submit"
            :text="this.value && this.value.id ? 'Update': 'Create'"
            :loading="loading"
            :block="true"
            class="btn btn-lg btn-block "
        />
      </div>
    </d-form>
  </div>
</template>

<script>
import ImageSelect from "@/components/Common/ImagePicker";
import embApi from "@/store/api/emb";
import {get} from 'lodash'
import DButton from "@/components/Common/DButton";
import ToastMixin from "@/mixins/ToastMixin";
import DForm from "@/components/Form/DForm";
import DFormInput from "@/components/Form/DFormInput";
import DFormFile from "@/components/Form/DFormFile";

export default {
  name: "AddNewEMBForm",
  mixins: [ToastMixin],
  components: {
    DFormFile,
    DFormInput,
    DForm,
    DButton,
    ImageSelect
  },
  props: {
    value: Object,
  },
  data() {
    let designs = get(this.value, 'designs', null);
    if (typeof designs === 'string') {
      try {
        designs = JSON.parse(designs)
      } catch (e) {

      }
    }
    return {
      form: {
        name: get(this.value, 'name', ''),
        designs: designs,
        designCost: get(this.value, 'designCost', null),
        thumb: get(this.value, 'thumb', null)
      },
      loading: false
    }
  },
  computed: {
    isUpdate() {
      return !!this.value
    }
  },
  methods: {
    async doCreate() {
      this.loading = true
      try {
        const api = embApi(this.$store.dispatch)
        const {data} = this.value && this.value.id ? await api.updateEMB(this.value.id, this.form) : await api.createNewEMB(
            this.form
        );
        this.$emit('success', data)
      } catch (e) {
        this.toastError(e.data.message)
        console.log(e)
      }
    }
  }
}
</script>